const mediaList = [
  'mobile',
  'tablet',
  'tabletPortrait',
  'tabletLandscape',
  'exceptMobile',
  'exceptDesktop',
  'desktop',
]


export default mediaList
